import { Session } from './session';
import createOrUpdateCsrSessionCookie from './createOrUpdateCsrSessionCookie';
import { v4 as uuidv4 } from 'uuid';

const initializeCsrSession = (): Session => {
  const session: Session = {
    favoriteStoreId: null,
    guid: uuidv4(),
    isPersisted: true,
    latestSelectedDeliveryMethod: null,
    selectedWishlist: null,
    tokens: null,
    showOverheadComponent: true
  };
  createOrUpdateCsrSessionCookie(session);
  return session;
};

export default initializeCsrSession;
